/* Goiat · Añadir a la cesta desde la rejilla, de un toque.
   Cada tarjeta lleva un «+» (snippets/goiat-product-card.liquid). Al tocarlo la vela entra en la cesta sin salir
   de la página; el botón pasa a ser un contador con «−» para deshacer. Una barra abajo va sumando y dice cuánto
   falta para el combo. Los números vienen de snippets/goiat-quick-config.liquid (que los lee de goiat-terms). */
(function () {
  'use strict';
  var cfgEl = document.getElementById('goiat-quick-config');
  if (!cfgEl) return;
  var cfg;
  try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  var velas = {};
  (cfg.velas || []).forEach(function (id) { velas[id] = true; });
  var words = String(cfg.words || '').split(',');
  var T = cfg.t || {};
  /* Textos de snippets/goiat-quick-config.liquid (claves goiat.quick_config.*): «{n}», «{price}»… se rellenan aquí. */
  function tr(key, vars) {
    return String(T[key] || '').replace(/\{(\w+)\}/g, function (m, k) { return vars && k in vars ? vars[k] : m; });
  }
  var cart = null;
  var bar = null;
  var busy = false;

  function money(c) { return (c / 100).toFixed(2).replace('.', ',') + ' €'; }
  function controls() { return [].slice.call(document.querySelectorAll('[data-gquick]')); }
  function qtyOf(id) {
    var q = 0;
    if (cart) cart.items.forEach(function (it) { if (String(it.variant_id) === String(id)) q += it.quantity; });
    return q;
  }

  function paint() {
    controls().forEach(function (el) {
      var q = qtyOf(el.dataset.id);
      var minus = el.querySelector('[data-gquick-minus]');
      var num = el.querySelector('[data-gquick-n]');
      el.classList.toggle('is-on', q > 0);
      minus.hidden = q === 0;
      num.hidden = q === 0;
      num.textContent = q;
      var wrap = el.closest('.gcard-q');
      if (wrap) wrap.classList.toggle('is-picked', q > 0);
    });
    paintBar();
  }

  function buildBar() {
    bar = document.createElement('div');
    bar.className = 'gqbar';
    bar.innerHTML =
      '<span class="gqbar__dots" aria-hidden="true"></span>' +
      '<span class="gqbar__info" aria-live="polite"><span class="gqbar__sum"></span><span class="gqbar__hint"></span></span>' +
      '<a class="gqbar__go" href="' + cfg.cartUrl + '">' + tr('view_cart') + '</a>';
    document.body.appendChild(bar);
    if ('IntersectionObserver' in window) {
      var packs = document.querySelectorAll('[data-gpack-box]');
      if (packs.length) {
        var seen = 0;
        var io = new IntersectionObserver(function (es) {
          es.forEach(function (e) { seen += e.isIntersecting ? 1 : -1; });
          bar.classList.toggle('is-away', seen > 0);
        });
        [].forEach.call(packs, function (p) { io.observe(p); });
      }
    }
  }

  function paintBar() {
    if (!cfg.bar || !controls().length) return;
    if (!bar) buildBar();
    var n = 0;
    var count = cart ? cart.item_count : 0;
    if (cart) cart.items.forEach(function (it) { if (velas[it.variant_id]) n += it.quantity; });
    var open = count > 0;
    bar.classList.toggle('is-open', open);
    document.documentElement.classList.toggle('has-gqbar', open);
    if (!open) return;
    var dots = '';
    for (var i = 1; i <= cfg.units; i++) dots += '<i' + (i <= n ? ' class="on"' : '') + '></i>';
    bar.querySelector('.gqbar__dots').innerHTML = dots;
    /* El gancho es la tercera vela (Lucas, 17-10-2026): la barra nunca cuenta más de tres. Con tres o más dice
       «Pack de tres» y lo que trae; con dos, lo que cuesta de verdad la tercera (descuento y envío incluidos). */
    var packed = cfg.units > 1 && cfg.pct > 0 && n >= cfg.units;
    var label = (packed ? tr('bar_pack', { units: words[cfg.units] || cfg.units })
      : (n === count ? tr(n === 1 ? 'candle_one' : 'candle_other', { n: n }) : tr(count === 1 ? 'item_one' : 'item_other', { n: count }))) + ' · ';
    bar.querySelector('.gqbar__sum').textContent = label + money(cart.total_price);
    var left = cfg.units - n;
    var hint;
    var perks = cfg.perks || tr('pct_off', { pct: cfg.pct });
    if (cfg.units > 1 && cfg.pct > 0 && left === 1 && n > 0) {
      var velasTotal = 0;
      cart.items.forEach(function (it) { if (velas[it.variant_id]) velasTotal += it.original_line_price; });
      var p = velasTotal / n;
      var others = cart.total_price - velasTotal;
      var con = Math.max(others, 0) + Math.round(p * cfg.units * (100 - cfg.pct) / 100);
      if (!(cfg.free > 0 && con >= cfg.free)) con += cfg.ship;
      var ahora = cart.total_price + (cfg.free > 0 && cart.total_price >= cfg.free ? 0 : cfg.ship);
      var extra = con - ahora;
      hint = extra > 0
        ? tr('third_costs', { price: money(extra), perks: perks })
        : tr('one_left', { perks: perks });
    } else if (cfg.units > 1 && cfg.pct > 0 && left > 0) {
      hint = tr('left', { left: words[left] || left, units: words[cfg.units] || cfg.units, perks: perks });
    } else if (packed) {
      hint = tr('applied', { perks: perks });
    } else if (cfg.free > 0 && cart.total_price >= cfg.free) {
      hint = tr('free_ship');
    } else {
      hint = tr('ship', { price: money(cfg.ship) });
    }
    bar.querySelector('.gqbar__hint').textContent = hint;
  }

  function refreshBubble() {
    fetch(cfg.root + '?sections=cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var el = document.getElementById('cart-icon-bubble');
        if (!el || !j['cart-icon-bubble']) return;
        var fresh = new DOMParser().parseFromString(j['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
        if (fresh) el.innerHTML = fresh.innerHTML;
      })
      .catch(function () {});
  }

  function load() {
    return fetch(cfg.cartJs, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { cart = c; paint(); });
  }

  function post(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); });
  }

  function say(el, text) {
    var wrap = el.closest('.gcard-q');
    if (!wrap) return;
    var m = wrap.querySelector('.gquick__msg');
    if (!m) { m = document.createElement('p'); m.className = 'gquick__msg'; m.setAttribute('role', 'alert'); wrap.appendChild(m); }
    m.textContent = text;
    clearTimeout(m._t);
    m._t = setTimeout(function () { m.remove(); }, 4000);
  }

  function change(el, delta) {
    if (busy) return;
    busy = true;
    el.classList.add('is-busy');
    var id = el.dataset.id;
    var q = qtyOf(id);
    var req = delta > 0
      ? post(cfg.addUrl, { items: [{ id: +id, quantity: 1 }] })
      : post(cfg.changeUrl, { id: String(id), quantity: Math.max(q - 1, 0) });
    req.then(function (res) {
      if (!res.ok) say(el, res.body.description || res.body.message || tr('add_error'));
      return load();
    }).catch(function () {
      say(el, tr('add_retry'));
    }).then(function () {
      busy = false;
      el.classList.remove('is-busy');
      if (delta > 0) { el.classList.remove('is-bump'); void el.offsetWidth; el.classList.add('is-bump'); }
      refreshBubble();
    });
  }

  document.addEventListener('click', function (e) {
    var plus = e.target.closest('[data-gquick-plus]');
    var minus = e.target.closest('[data-gquick-minus]');
    if (!plus && !minus) return;
    e.preventDefault();
    change((plus || minus).closest('[data-gquick]'), plus ? 1 : -1);
  });

  function boot() { if (controls().length) load(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  window.addEventListener('pageshow', function (e) { if (e.persisted) boot(); });
})();
